import graphql from 'babel-plugin-relay/macro'

export default graphql`
  query CountPropertyUnitAppointmentHistoryQuery(
    $filters: [Filter]
    $companyId: ID!
  ) {
    Me {
      id
      Company(id: $companyId) {
        data: countAppointments(options: { filters: $filters })
      }
    }
  }
`
